// extracted by mini-css-extract-plugin
export var beerDropdown = "navbar-module--beer-dropdown--68e07";
export var logoImg = "navbar-module--logoImg--6b84c";
export var nav = "navbar-module--nav--d3373";
export var navbar = "navbar-module--navbar--f3ad1";